import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function FinalCloseSection() {
  return <section className="py-24 bg-white" data-id="element-104">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="max-w-2xl mx-auto text-center" data-id="element-106">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1E293B] mb-8" data-id="element-107">
            Stop Guessing.
            <br data-id="element-108" />
            Start Structuring.
          </h2>

          <p className="text-lg text-[#475569] mb-2" data-id="element-109">
            Your Frenchie doesn't need another experiment.
          </p>
          <p className="text-xl font-semibold text-[#1E293B] mb-4" data-id="element-110">
            They just need a routine that works.
          </p>
          <p className="text-lg text-[#475569] mb-10" data-id="element-111">Let's get started.</p>

          <Button size="lg" icon={ArrowRight} onClick={() => window.open('https://zensturia.com/cart/51508367163709:1', '_blank')} data-id="element-112">
            Get Instant Access Now
          </Button>
        </motion.div>
      </div>
    </section>;
}